var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Tooltip", {
    ref: "tooltipWishlist",
    attrs: {
      text: _vm.tooltipText,
      whitespace: _vm.isMobile ? "normal" : "nowrap",
      width: _vm.isMobile && _vm.isInProductListCard ? 150 : 250,
      "custom-left-offset": _vm.isInProductListCard ? 44 : 0,
      timeout: 6000
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }